import { Helmet } from 'react-helmet-async'

// @ts-expect-error TS7016
import { ArtworkEditor } from '@domain-group/artwork-builder'
import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import useArtworkBuilder from '../../hooks/useArtworkBuilder'

type QueryParams = {
  artworkId?: string,
  redirect?: string,
}

const EditPage = () => {
  const queryParams: QueryParams = parsePermittedQueryParams(getQueryParamsFromHash(), [
    'artworkId',
    'redirect',
  ])

  const { artworkId, redirect } = queryParams

  // @ts-expect-error TS2322
  const artworkBuilderPayload = useArtworkBuilder({ artworkId, redirect })
  const {
    callbacks: {
      deleteArtwork,
      fetchEditorOptions,
      goBack,
    },
  } = artworkBuilderPayload

  return (
    <>
      <Helmet>
        <title>Artwork Builder | Realhub</title>
      </Helmet>

      <ArtworkEditor
        callbacks={{
          deleteArtwork,
          fetchEditorOptions,
          goBack,
        }}
      >
        <ArtworkEditor.Header />
        <ArtworkEditor.Canvas />
      </ArtworkEditor>
    </>
  )
}

export default EditPage
